import { component } from 'picoapp';
import { setUrlParam, getUrlParam } from 'utils/url';

export default component(async (node) => {
  const paginateButton:HTMLButtonElement = node.querySelector('[data-load-more]');
  const paginationCount:HTMLSpanElement = node.querySelector('[data-pagination-count]');
  const paginationProgressbar:HTMLElement = node.querySelector('[data-pagination-progress]');
  const articleOutput = node.querySelector('[data-article-output]');
  const { pageSize, handle: blogHandle, total: totalArticles } = JSON.parse(node.dataset.config);

  let loadedArticles = pageSize;
  let currentPage = parseInt(getUrlParam('page') ?? '1', 10);

  const fetchArticlesByPages = async () => {
    const fetches = [];

    for (let p = 1; p <= currentPage; p += 1) {
      fetches.push(fetch(`${blogHandle}?view=data&page=${p}`).then((r) => r.text()));
    }

    return Promise.all(fetches).then((data) => data.join(''));
  };

  const updatePagination = (count) => {
    loadedArticles += count;

    const progress = (loadedArticles / totalArticles) * 100;
    paginationProgressbar.style.width = `${progress}%`;
    paginationCount.innerText = loadedArticles;

    setUrlParam('page', currentPage.toString());

    if (loadedArticles >= totalArticles) {
      paginateButton.hidden = true;
      paginateButton.disabled = true;
    } else {
      paginateButton.hidden = false;
      paginateButton.disabled = false;
    }
  };

  const getNextPage = () => {
    currentPage += 1;
    paginateButton.disabled = true;
    fetch(`${blogHandle}?view=data&page=${currentPage}`)
      .then((data) => data.text())
      .then((html) => {
        const element = document.createElement('div');
        element.insertAdjacentHTML('afterbegin', html);
        articleOutput.insertAdjacentHTML('beforeend', html);
        updatePagination(element.querySelectorAll('[data-article]').length);
      });
  };

  if (currentPage > 1) {
    paginateButton.hidden = true;
    fetchArticlesByPages().then((html) => {
      const element = document.createElement('div');
      element.insertAdjacentHTML('afterbegin', html);
      const articlesCount = element.querySelectorAll('[data-article]').length;
      loadedArticles = 0;
      articleOutput.innerHTML = html;
      updatePagination(articlesCount);
    });
  }

  paginateButton.addEventListener('click', () => {
    getNextPage();
  });
});
